import React from 'react'
import Icon from '../../../components/icon'

export function buildSponsorPledgeStepperItems(styles, t, step, phase) {
  const stepperItem = (n, labelKey) => {
    const active = step === n && phase === 'wizard'
    const done = phase === 'wizard' && step > n
    const itemCls = [
      styles.stepItem,
      active ? styles.stepItemActive : '',
      done ? styles.stepItemDone : '',
    ]
      .filter(Boolean)
      .join(' ')
    const circleCls = [
      styles.stepCircle,
      active ? styles.stepCircleActive : '',
      done ? styles.stepCircleDone : '',
    ]
      .filter(Boolean)
      .join(' ')
    return (
      <React.Fragment key={n}>
        {n > 1 ? <div className={styles.stepConnector} /> : null}
        <div className={itemCls}>
          <div className={circleCls}>
            {done ? <Icon name="check" style={{ fontSize: 11 }} /> : n}
          </div>
          <div className={styles.stepLabel}>{t(labelKey)}</div>
        </div>
      </React.Fragment>
    )
  }

  return [
    stepperItem(1, 'sponsorPledgeFlow.steps.pledge'),
    stepperItem(2, 'sponsorPledgeFlow.steps.allocation'),
    stepperItem(3, 'sponsorPledgeFlow.steps.information'),
    stepperItem(4, 'sponsorPledgeFlow.steps.marketing'),
    stepperItem(5, 'sponsorPledgeFlow.steps.review'),
  ]
}
